export const interviewData = {
    title: "interview.title",
    subtitle: "interview.subtitle",
    author: {
        name: "dr Marta Znajmiecka",
        role: "interview.author.role"
    },
    intros: [
        "interview.intros.0",
        "interview.intros.1",
        "interview.intros.2"
    ],
    sections: [
        {
            id: 1,
            title: "interview.sections.0.title",
            content: "interview.sections.0.content"
        },
        {
            id: 2,
            title: "interview.sections.1.title",
            content: "interview.sections.1.content"
        },
        {
            id: 3,
            title: "interview.sections.2.title",
            content: "interview.sections.2.content"
        },
        {
            id: 4,
            title: "interview.sections.3.title",
            content: "interview.sections.3.content"
        },
        {
            id: 5,
            title: "interview.sections.4.title",
            content: "interview.sections.4.content"
        }
    ],
    calmnestInfo: {
        title: "interview.calmnestInfo.title",
        contents: [
            "interview.calmnestInfo.content.0",
            "interview.calmnestInfo.content.1",
            "interview.calmnestInfo.content.2"
        ],
        website: "www.calmnest.org.pl",
        websiteUrl: "https://www.calmnest.org.pl"
    },
    bibliographys: [
        "interview.bibliography.0",
        "interview.bibliography.1",
        "interview.bibliography.2",
        "interview.bibliography.3"
    ]
};

export default interviewData;